const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const ScrollArea = require("./ScrollArea");
const fadeTheme = require("./styles/ScrollFadeDefault.css");
const LoadGuard = require("./LoadGuard");
const SequenceRow = require("./SequenceRow");

const withVaultDispatch = require("../hoc/withVaultDispatch");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const AT = require("../vault/ActionTypes");
const Derived = require("../vault/Derived");
const {
	atChapterByParams,
	atLibraryChaptersByGrade,
} = require("../vault/StateCursors");
const ErrorUtil = require("../../../shared/ErrorUtil");
const OpsLibrary = require("../../library/vault/OpsLibrary");

const ChapterSection = require("../../../shared/ChapterSection");
const GradeChapter = require("../../../shared/GradeChapter");
const MiscBlockUtil = require("../../../shared/MiscBlockUtil");

const styles = require("./styles/SequenceChapter.css");

const getPropsFromVault = function(props, vaultState) {
	const {gradeNumber, chapterIndex} = props;
	const chapterID = GradeChapter.toChapterID(gradeNumber, chapterIndex);
	const chapter = atChapterByParams(
		vaultState,
		gradeNumber,
		chapterIndex
	).get();

	const {previous, next} = GradeChapter.getAdjacentChapters(
		gradeNumber,
		chapterIndex
	);

	const libraryChapters = atLibraryChaptersByGrade(
		vaultState,
		gradeNumber
	).get();

	return {
		chapterID,
		chapter,
		libraryChapters,
		auxBlocks: Derived.getChapterAuxBlocks(vaultState, chapterID),
		previousChapterID: _.get(previous, "id", null),
		nextChapterID: _.get(next, "id", null),
		sectionBlockMap: Derived.getSectionBlockMapForChapter(
			vaultState,
			chapterID
		),
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault, {
		forLoggedIn: true,
	});
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "SequenceChapter",

		propTypes: {
			// passed down from parent
			user: PT.object.isRequired,
			page: PT.object.isRequired,

			// props based on slider nav and not user or page above
			gradeNumber: PT.number.isRequired,
			chapterIndex: PT.number.isRequired,
			clickHandler: PT.func,

			// Tutorial props
			disableNavigation: PT.bool,

			// Injected by HOCs
			chapterID: PT.number,
			chapter: PT.object,
			libraryChapters: PT.object,
			auxBlocks: PT.object,
			previousChapterID: PT.number,
			nextChapterID: PT.number,
			dispatch: PT.func.isRequired,
			sectionBlockMap: PT.object.isRequired,
		},

		getInitialState: function() {
			this.dispatchTimeoutIDs = [];
			this.dispatchWithDelay = action => {
				this.dispatchTimeoutIDs.push(
					setTimeout(() => this.props.dispatch(action), 100)
				);
			};
			this.clearDelayedDispatches = () => {
				this.dispatchTimeoutIDs.forEach(id => clearTimeout(id));
				this.dispatchTimeoutIDs = [];
			};
			return {};
		},

		componentDidMount: function() {
			const chapterLoaded = _.get(this.props, "chapter.load") === "done";
			if (chapterLoaded) this.loadAdjacentChapters();
		},

		componentDidUpdate: function() {
			const chapterLoaded = _.get(this.props, "chapter.load") === "done";
			if (chapterLoaded) this.loadAdjacentChapters();
		},

		componentWillUnmount: function() {
			this.clearDelayedDispatches();
		},

		UNSAFE_componentWillReceiveProps: function(nextProps) {
			if (
				this.props.chapter &&
				nextProps.chapter &&
				this.props.chapter.chapterID !== nextProps.chapter.chapterID
			) {
				this.clearDelayedDispatches();
			}
		},

		clickHandler: function() {
			this.props.clickHandler && this.props.clickHandler();
			return true;
		},

		bookSectionRead: function(sectionID) {
			const {libraryChapters} = this.props;
			const chapterID = this.props.chapter.chapterID;
			const libraryChapter = _.get(libraryChapters, chapterID);
			if (_.isEmpty(libraryChapter)) return false;

			return OpsLibrary.librarySectionCompletelyRead(sectionID, libraryChapter);
		},

		loadChapter: function() {
			this.dispatchWithDelay({
				type: AT.LOAD_CHAPTER_REQUEST,
				userID: this.props.user.userID,
				chapterID: this.props.chapter.chapterID,
			});
		},

		loadLibraryChapters: function() {
			const {user, gradeNumber} = this.props;
			if (!user.userID) {
				ErrorUtil.log(
					"E_LOAD_LIBRARY_NO_USER",
					"SequenceChapter " + JSON.stringify(user)
				);
			}
			const chapterIDs = GradeChapter.getAllChaptersForGrade(gradeNumber) || [];
			if (chapterIDs.length > 0) {
				this.props.dispatch({
					type: AT.LOAD_LIBRARY_CHAPTERS_REQUEST,
					userID: user.userID,
					chapterIDs,
				});
			}
		},

		loadAdjacentChapters: function() {
			const {user, previousChapterID, nextChapterID} = this.props;
			if (previousChapterID && this.lastPreviousID !== previousChapterID) {
				this.lastPreviousID = previousChapterID;
				this.dispatchWithDelay({
					type: AT.LOAD_CHAPTER_ANTICIPATED_REQUEST,
					userID: user.userID,
					chapterID: previousChapterID,
				});
			}
			if (nextChapterID && this.lastNextID !== nextChapterID) {
				this.lastNextID = nextChapterID;
				this.dispatchWithDelay({
					type: AT.LOAD_CHAPTER_ANTICIPATED_REQUEST,
					userID: user.userID,
					chapterID: nextChapterID,
				});
			}
		},

		getBlockModelData: function(blockModel) {
			const leanModel = _.pick(blockModel, [
				"displayName",
				"gradeNumber",
				"chapterIndex",
				"blockIndex",
				"bookSectionID",
				"videoSetID",
				"blockID",
				"requirementLevel",
				"unlocked",
				"percentageComplete",
				"timesCompleted",
				"stars",
				"starsObtained",
			]);
			const sectionID = _.get(leanModel, "bookSectionID");
			const pages =
				!_.isNil(sectionID) &&
				_.get(ChapterSection.getSectionData(sectionID), "page");

			return _.extend(leanModel, {pages});
		},

		renderChapter: function() {
			const {
				user,
				chapterID,
				chapterIndex,
				sectionBlockMap,
				page,
				gradeNumber,
			} = this.props;

			const content = [];
			const pagesLog = [];

			const sectionIDs = [0].concat(
				ChapterSection.getChapterSections(chapterID)
			);
			_.each(sectionIDs, sectionID => {
				if (sectionID !== 0) {
					// insert book chapter row
					const sectionData = ChapterSection.getSectionData(sectionID);
					const fauxBlock = {
						displayName: _.get(sectionData, "name"),
						gradeNumber,
						chapterIndex,
						bookSectionID: sectionID,
						isComplete: this.bookSectionRead(sectionID),
						pages: _.get(sectionData, "page"),
						blockType: "library",
						unlocked: true, // readings are always unlocked
					};
					content.push(
						<div
							className={styles.scrollAreaRow}
							key={`library-section-${sectionID}`}
						>
							<SequenceRow
								user={user}
								type={"playlist"}
								page={page}
								blockModel={fauxBlock}
								clickHandler={
									this.props.disableNavigation ? _.noop : this.clickHandler
								}
								disableNavigation={this.props.disableNavigation}
							/>
						</div>
					);
				}

				_.each(sectionBlockMap[sectionID], blockModel => {
					const leanModel = this.getBlockModelData(blockModel);
					_.extend(leanModel, {
						hasVideo: !!_.get(leanModel, "videoSetID"),
						isComplete: MiscBlockUtil.isBlockComplete(leanModel),
						blockType: "trainer",
					});
					const firstPage = _.get(leanModel, "pages[0]");
					if (
						(firstPage || firstPage === 0) &&
						!_.includes(pagesLog, firstPage)
					) {
						pagesLog.push(firstPage);
					}
					content.push(
						<div
							className={styles.scrollAreaRow}
							key={`block-trainer-${blockModel.blockID}`}
						>
							<SequenceRow
								user={user}
								type={"playlist"}
								page={page}
								blockModel={leanModel}
								index={_.get(leanModel, "blockIndex") + 1}
								clickHandler={this.clickHandler}
								disableNavigation={this.props.disableNavigation}
							/>
						</div>
					);
				});
			});

			const testBlock = this.getBlockModelData(
				_.get(this.props.auxBlocks, "test.model")
			);
			_.extend(testBlock, {
				isComplete: MiscBlockUtil.isBlockComplete(testBlock),
				blockType: "test",
			});
			content.push(
				<div
					className={styles.scrollAreaRow}
					key={`block-test-${testBlock.blockID}`}
				>
					<SequenceRow
						user={user}
						type={"playlist"}
						page={page}
						blockModel={testBlock}
						clickHandler={
							this.props.disableNavigation ? this.props.clickHandler : _.noop
						}
						disableNavigation={this.props.disableNavigation}
					/>
				</div>
			);

			return (
				<div className={styles.chapter}>
					<ScrollArea
						fadeTheme={fadeTheme}
						useWonkyCursor={true}
						hasXScroll={false}
						useGlobalHotkeysForY={true}
						useMouseMoveToScroll={true}
						yBarClassName={styles.yBar}
						yThumbClassName={styles.yThumb}
					>
						{content}
					</ScrollArea>
				</div>
			);
		},

		renderLibraryLoadGuard: function() {
			const {libraryChapters} = this.props;
			return (
				<LoadGuard
					identifier="libraryChapter"
					status={libraryChapters}
					requestLoad={this.loadLibraryChapters}
					loadingView="logo"
					loadingViewClass={styles.loading}
					logoColorType="blue"
					renderLoaded={this.renderChapter}
					needsBundle="library"
				/>
			);
		},

		render: function() {
			const {chapter} = this.props;
			const chapterID = _.get(chapter, "chapterID") || "";
			return (
				<LoadGuard
					identifier={"chapter" + chapterID}
					status={chapter}
					requestLoad={this.loadChapter}
					loadingView="logo"
					loadingViewClass={styles.loading}
					logoColorType="blue"
					renderLoaded={this.renderLibraryLoadGuard}
					ignoreLoadLoop={true}
				/>
			);
		},
	})
);
